<template>
  <div class="wrapper">
    <h6 class="card-title">Steps to authorise your account:</h6>
    <ul>
      <li>
        Truy cập
        <b><a href="https://poshmark.com/user/account-info" target="_blank">https://poshmark.com/user/account-info</a></b>
        để lấy tên tài khoản
      </li>
      <li>Điền thông tin vào biểu mẫu phía dưới(Dấu * là các trường bắt buộc) và lưu lại.</li>
      <li>Sử dụng extension đi kèm và tiến hành đăng nhập cho hệ thống</li>
    </ul>
    <div class="account_popup_wrap">
      <div class="account_popup_container row">
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Shop Name*</label>
          <input class="form-control mt-2" type="text" name="name" :value="data.name" @change.stop.prevent="changeName" />
        </div>
        <div class="position-relative form-group col-12 disabled-if-edit-account">
          <label class="col-12 mb-0 p-0">User Name*</label>
          <small class="form-text text-muted mt-0">
            <a class="get_account_account_name" href="https://poshmark.com/user/account-info" target="#">Get User Name</a>
          </small>
          <input class="form-control mt-2" type="text" :value="token.user_name" @change.stop.prevent="changeTokenUserName" />
        </div>
        <div class="position-relative form-group col-12">
          <label>Proxy*</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">IP</span>
            </div>
            <input name="proxy" type="text" class="form-control" placeholder="ip:port:user:password" :value="meta.proxy" @change.stop.prevent="changeMetaProxy" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  computed: {
    action() {
      return this.config?.action
    },
    storeId() {
      return this.config?.storeId
    },
    accountId() {
      return this.config?.accountId
    },
    submitUri() {
      return `sale-account/update/${this.accountId}`
    },
    data() {
      return this.store.getter('', {})
    },
    meta() {
      return this.data.meta || {}
    },
    token() {
      return this.data.token || {}
    }
  },
  mounted() {
    this.$emitter.on('Modal.SaleAccount.Edit.Submit', this.submit)
  },
  unmounted() {
    this.$emitter.off('Modal.SaleAccount.Edit.Submit', this.submit)
  },
  methods: {
    changeName(e) {
      this.store.commit('name', e.target.value)
    },
    changeTokenUserName(e) {
      this.store.commit('token.user_name', e.target.value)
    },
    changeMetaProxy(e) {
      this.store.commit('meta.proxy', e.target.value)
    },
    submit(data) {
      this.submitForm(data, {
        done: () => {
          this.$emitter.emit('TableList.Refresh')
          this.$emit('close')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
